// Feedback domain constants — single source of truth for all feedback-related
// enums, option lists, and color mappings used across admin feedback components.

export const STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'in_review', label: 'In Review' },
  { value: 'fixed', label: 'Fixed' },
  { value: 'wont_fix', label: "Won't Fix" },
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'closed', label: 'Closed' },
];

export const CATEGORY_OPTIONS = [
  { value: 'bug_report', label: 'Bug Report' },
  { value: 'feature_request', label: 'Feature Request' },
  { value: 'general_feedback', label: 'General Feedback' },
  { value: 'question', label: 'Question' },
];

export const PRIORITY_OPTIONS = [
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];

/** MUI Chip color for each status value. */
export const STATUS_COLORS = {
  open: 'primary',
  in_review: 'warning',
  fixed: 'success',
  wont_fix: 'default',
  duplicate: 'default',
  closed: 'error',
};

/** MUI Chip color for each priority value. */
export const PRIORITY_COLORS = {
  high: 'error',
  medium: 'warning',
  low: 'success',
};
